"use client";
import FieldValue from "@/components/shared/review/fieldValue";
import { Separator } from "@/components/ui/separator";
import { useIsMobile } from "@/hooks/useMobile";
import Image, { StaticImageData } from "next/image";
import { useRouter } from "next/navigation";
interface MemberCardProps {
  id: number;
  slug?: string;
  memberNumber?: string;
  imageUrl: string | StaticImageData | undefined;
  name?: string;
  position?: string;
  positionSlug?: string;
  dapil?: string;
  fractionLogo?: string;
  fractionName?: string;
}
const MemberCard = ({
  id,
  imageUrl,
  slug,
  memberNumber,
  name = "Nama Anggota",
  position = "Komisi Anggota",
  positionSlug,
  fractionLogo,
  fractionName,
  dapil,
}: MemberCardProps) => {
  const router = useRouter();
  const isMobile = useIsMobile();
  const goToMemberDetail = () => {
    router.push(`/${positionSlug}/${slug}`);
  };
  return (
    <div
      className="lg:w-[30rem] xl:w-[40rem] w-full cursor-pointer overflow-hidden"
      onClick={goToMemberDetail}
    >
      <figure>
        <div className="flex gap-2 relative">
          <div className="w-24 h-32 md:w-48 md:h-64 flex-shrink-0">
            <Image
              src={imageUrl ?? "/assets/images/dpr-no.jpg"}
              alt={name}
              width={300}
              height={400}
              className="w-full h-full object-cover"
            />
          </div>
          <span className="absolute top-0 left-0 bg-secondary-400 text-white font-medium px-2 py-1">
            {memberNumber ?? "-"}
          </span>
          {!isMobile ? (
            <figcaption className="flex flex-col justify-between w-full">
              <div>
                <FieldValue
                  label="DAPIL"
                  variant="colon"
                  valueClassName="w-56 sm:w-80"
                  className="!items-start"
                >
                  {dapil ?? "-"}
                </FieldValue>
                <FieldValue
                  label="NAMA"
                  valueClassName="w-56 sm:w-80"
                  variant="colon"
                  className="font-medium text-primary-700 !items-start"
                >
                  {name ?? "-"}
                </FieldValue>
                <FieldValue
                  label="JABATAN"
                  variant="colon"
                  valueClassName="w-56 sm:w-80"
                  className="!items-start"
                >
                  {position ?? "-"}
                </FieldValue>
              </div>
              <Image
                src={fractionLogo ?? "/assets/images/no-image.png"}
                alt={fractionName ?? "Partai"}
                width={300}
                height={400}
                className="w-16 h-16 object-contain ml-2"
              />
              <div>
                <Separator className="border-2 border-primary-700" />
                <p>{fractionName}</p>
              </div>
            </figcaption>
          ) : (
            <figure>
              <h4 className="font-semibold text-primary-700 mb-2">
                {name ?? "-"}
              </h4>
              <Image
                src={fractionLogo ?? "/assets/images/no-image.png"}
                alt={fractionName ?? "Partai"}
                width={300}
                height={400}
                className="w-12 h-12 object-contain"
              />
            </figure>
          )}
        </div>
        <div className="md:hidden mt-2 md:mt-0 border-b pb-3 md:pb-0">
          <FieldValue
            label="DAPIL"
            variant="colon"
            labelClassName="!w-20"
            className="!items-start"
            valueClassName="w-full line-clamp-2"
          >
            {dapil ?? "-"}
          </FieldValue>
          <FieldValue
            label="JABATAN"
            variant="colon"
            labelClassName="!w-20"
            className="!items-start"
            valueClassName="w-full line-clamp-2"
          >
            {position ?? "-"}
          </FieldValue>
          <FieldValue
            label="PARTAI"
            variant="colon"
            labelClassName="!w-20"
            className="!items-start"
            valueClassName="w-full line-clamp-2"
          >
            {fractionName ?? "-"}
          </FieldValue>
        </div>
      </figure>
    </div>
  );
};

export default MemberCard;
